'use strict'
import request from '@/utils/request'
// import qs from 'qs'

const model = {
  login (data) {
    return request({
      url: '/auth',
      method: 'post',
      data: data
    })
  },

  logout () {
    return request({
      url: '/logout',
      method: 'post'
    })
  },

  getUserInfo () {
    return request({
      url: '/user/loginInfo',
      method: 'get'
    })
  }
}

export default model



// WEBPACK FOOTER //
// ./src/api/user.js